/**
 * Decide whether a flow node may run, given the risk-session state.
 *
 * Server-side nodes (integration / decision / expression / bedrock_prompt) send
 * the risk replay token, so they need a resolved risk session. The runner must
 * NOT error the instant such a node becomes current before the session opens —
 * it must WAIT (show a loading state) and proceed once the token arrives, and
 * only ERROR if the session genuinely failed. Page / redirect / result nodes
 * never need the token.
 */
const RISK_REQUIRED_KINDS = new Set(['integration', 'decision', 'expression', 'bedrock_prompt']);

export type RiskGate =
  | { state: 'ready' }
  | { state: 'wait' }
  | { state: 'error'; message: string };

export function riskGateForNode(
  nodeKind: string,
  risk: { token?: string | null; session_id?: string | null } | null,
  riskError: string | null,
): RiskGate {
  if (!RISK_REQUIRED_KINDS.has(nodeKind)) return { state: 'ready' };
  if (risk?.token && risk?.session_id) return { state: 'ready' };
  if (riskError) return { state: 'error', message: riskError };
  return { state: 'wait' };
}
